import { render, staticRenderFns } from "./field-text-v2.vue?vue&type=template&id=b23c02c4&"
import script from "./field-text-v2.vue?vue&type=script&lang=ts&"
export * from "./field-text-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports